import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
} from "@mui/material";
import { Button } from "@/app/global-components/button";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { routes } from "@/consts";

interface CompanyWarningPopupProps {
  open: boolean;
}

const CompanyWarningPopup: React.FC<CompanyWarningPopupProps> = ({
  open = true,
}) => {
  const navigate = useNavigate();
  const { locale } = useLocale();
  const { t } = useTranslate(locale);

  const handleRedirect = () => {
    navigate(routes.settings);
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>{t("alerts.warning.warning")}</DialogTitle>
      <DialogContent>
        <Box sx={{ py: 2 }}>
          <Typography variant="body1" color="error" gutterBottom>
            {t("company.notRegistered")}
          </Typography>
          <Typography variant="body2">
            {t("company.registrationRequired")}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          className="flex items-center bg-secondary-brightYellow shadow text-textcolor-black  py-2 px-4 text-sm"
          style={{ background: "#000", color: "#fff" }}
          type="submit"
          onClick={handleRedirect}
        >
          {t("actions.goToSettings")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompanyWarningPopup;
